import instanceMgrSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const instanceMgrActions = { ...actions, ...thunkActions };
export * as InstanceMgrTypes from './types';
export default instanceMgrSlice;
